import React from 'react';

import { countryTypes } from './actions'


const initialState = {
    isFetching: false,
    data: []
}


export function countries(state = initialState, action) {

    switch(action.type) {

        case countryTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case countryTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data

            return state

        default:
            return state
    }
}